// extracted by mini-css-extract-plugin
module.exports = {"recent-activity-control":"RecentActivityControl_recent-activity-control__1Crc5","control":"RecentActivityControl_control__2wG9F"};